"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExamApplicationModel = void 0;
var Model_1 = __importDefault(require("../Model"));
var ExamApplicationModel = /** @class */ (function (_super) {
    __extends(ExamApplicationModel, _super);
    function ExamApplicationModel(examApplication, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = examApplication.id;
        _this.applicationYear = examApplication.applicationYear;
        _this.duration = examApplication.duration;
        _this.examTitle = examApplication.examTitle;
        _this.examinationBoardId =
            examApplication.examinationBoardByExaminationBoardId || examApplication.examinationBoardId;
        _this.institutionId = examApplication.institutionByInstitutionId || examApplication.institutionId;
        _this.professionalTitle = examApplication.professionalTitle;
        return _this;
    }
    Object.defineProperty(ExamApplicationModel.prototype, "institution", {
        get: function () {
            return this.getters.institutionById(this.institutionId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExamApplicationModel.prototype, "examinationBoard", {
        get: function () {
            return this.getters.examinationBoardById(this.examinationBoardId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExamApplicationModel.prototype, "title", {
        get: function () {
            if (this.examTitle)
                return this.examTitle;
            if (this.institution && this.institution.title)
                return this.institution.title;
            return this.examinationBoard.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExamApplicationModel.prototype, "fullTitle", {
        get: function () {
            if (this.applicationYear)
                return this.title + " \u2022 " + this.applicationYear;
            return this.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExamApplicationModel.prototype, "text", {
        get: function () {
            var text = this.title;
            if (this.examinationBoardId) {
                text += this.examinationBoard.title + ' ';
            }
            if (this.institutionId) {
                text += this.institution.title + ' ';
            }
            return text.trim();
        },
        enumerable: false,
        configurable: true
    });
    ExamApplicationModel.__typename = 'ExamApplication';
    return ExamApplicationModel;
}(Model_1.default));
exports.ExamApplicationModel = ExamApplicationModel;
